<template>
    <main>
        <section class="intro">
            <div class="title">
                <h1>{{ copydeck.page_gift_card.title[lang]}}</h1>

                <figure>
                    <img :src="copydeck.gift_card_images.intro_heading[lang]" data-copydeck="gift_card_images.intro_heading" alt='' />
                </figure>

                <div class="content" v-html="copydeck.page_gift_card.text_intro[lang]">

                </div><!-- div.content -->
            </div>
        </section>

        <section class="detail">
            <div class="inner">

                <div class="grey-box">
                    <h2 v-html="copydeck.page_gift_card.subtitle_intro[lang]"></h2>

                    <div v-html="copydeck.page_gift_card.text_intro_details[lang]">

                    </div>
                    <div class="wrapper_btn">
                        <router-link :to="getRoute('order')" class="cta next">
                            <span>{{ copydeck.page_gift_card.btn_buy[lang] }}</span>
                        </router-link>
                    </div>
                </div>

            </div>

            <div class="spacer"></div>
        </section>
    </main>
</template>

<script>
export default {
    name: "Introduction",
}
</script>

<script setup>

    import {useMainStore}  from "../stores/main";
    import { storeToRefs } from "pinia";
    import { onMounted }    from "vue";

    let store = useMainStore();
    let { copydeck, lang } = storeToRefs(store);
    let { getRoute } = store;

    onMounted ( function ()
                {
                    if (parent)
                    {
                        const message = {
                            type: 'resize',
                        }

                        parent.postMessage(message);

                    }
                })
</script>
